import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { UserService } from '../../../services/user.service';
import { TaskService } from '../../services/task.service';
import { WorkflowUserService } from '../../services/workflow-user.service';
import { formatString } from '../../../utils/string-utils';

/**
 * Component for managing workflow tasks.
 */
@Component({
	selector: 'workflow-task-management',
	templateUrl: './task-management.component.html',
	styleUrl: './task-management.component.css'
})
export class TaskManagementComponent implements OnInit {
	@Input() taskGroup: any;

	LOCALIZATION: any;

	potentialOwners: any[] = [];
	inprogress: boolean = false;

	constructor(
		private modalService: NgbActiveModal,
		private alertsService: AlertsService,
		private taskService: TaskService,
		private workflowUserService: WorkflowUserService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadPotentialOwners();
	}

	private loadPotentialOwners(): void {
		this.workflowUserService.getPotentialTaskOwners(this.taskGroup.taskids, this.userService.user.username).then(
			(response: any) => {
				this.taskGroup.potentialOwners = response;
			},
			(err: any) => {
				console.error("Failed to fetch potential task owners", err);
			}
		);
	}

	/**
	 * Assigns task ownership.
	 */
	assignTasks(): void {
		this.inprogress = true;

		let payload = {
			taskIds: this.taskGroup.taskids,
			comment: this.taskGroup.comment,
			ownerId: this.taskGroup.owner
		};

		this.taskService.massAssign(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: "The selected " + ((this.taskGroup.taskids.length > 1) ? "tasks were" : "task was") + " successfully assigned to " + this.taskGroup.owner,
					delay: 5000
				});
				this.close();
			},
			(err: any) => {
				console.error("Failed to assign tasks", err);
				this.alertsService.error({
					message: "Failed to assign the selected " + ((this.taskGroup.taskids.length > 1) ? "tasks" : "task"),
				});
				this.inprogress = false;
			}
		);
	}

	/**
	 * Rejects the tasks.
	 */
	rejectTasks(): void {
		this.inprogress = true;

		let payload = {
			taskIds: this.taskGroup.taskids,
			comment: this.taskGroup.comment,
			ownerId: this.taskGroup.owner
		};

		this.taskService.massReject(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: formatString(this.LOCALIZATION.rejectedTasks, ((this.taskGroup.taskids.length > 1) ? "tasks were" : "task was")),
					delay: 5000
				});
				// Closes the main editor window, if open
				this.proceed();
			},
			(err: any) => {
				console.error("Failed to reject tasks", err);
				this.alertsService.error({
					message: formatString(this.LOCALIZATION.rejectedTasksError, ((this.taskGroup.taskids.length > 1) ? "tasks" : "task")),
				});
				this.inprogress = false;
			}
		);
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'workflowTaskManagement',
			mode: this.taskGroup.mode,
		};

		this.modalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
